import PlainModel from '@/modules/base/model/plain_model'

class RevenueModel extends PlainModel {
}
export default RevenueModel
